var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import clsx from 'clsx';
import { withForwardedRef } from '../utils/helpers/reactHelpers';
const PopupContentSC = styled.div `
  flex: 1 1 auto;
  /* add ios momentum scrolling.*/
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;
`;
const PopupContent = (props) => {
    const { children, forwardedRef, className: classNameProp, darkMode } = props, others = __rest(props, ["children", "forwardedRef", "className", "darkMode"]);
    const childrenWithProps = React.Children.map(children, (child) => {
        if (React.isValidElement(child) && darkMode) {
            return React.cloneElement(child, { mode: 'dark' });
        }
        return child;
    });
    return children ? (React.createElement(PopupContentSC, Object.assign({ ref: forwardedRef, className: clsx(classNameProp) }, others), childrenWithProps)) : null;
};
PopupContent.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    forwardedRef: PropTypes.any,
    className: PropTypes.string,
    darkMode: PropTypes.bool
};
PopupContent.defaultProps = {
    children: null,
    forwardedRef: React.createRef(),
    className: undefined,
    darkMode: null
};
export default withForwardedRef(PopupContent);
//# sourceMappingURL=PopupContent.js.map